import { Navigate, Outlet, useLocation } from "react-router";
import { useMe } from "../shared/api/session";
import { RouteSkeleton } from "../shared/skeleton/RouteSkeleton";
import { ScreenSkeleton } from "../shared/skeleton/ScreenSkeleton";

/** Guards signed-in routes. The API still checks every request; this only decides what to render. */
export function RequireSession() {
  const me = useMe();
  const location = useLocation();
  // The skeleton is the screen being opened (portal page, welcome, picker, onboarding), not a generic card.
  if (me.isPending) return <RouteSkeleton pathname={location.pathname} fallback={<ScreenSkeleton />} />;
  if (me.isError) return <ScreenSkeleton error onRetry={() => void me.refetch()} />;
  if (!me.data) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}
